import { FeatureList } from 'core/constants/common';
import Feature from './feature';

export default class CreateProfile extends Feature {
  constructor(disabledFeatures: string[]) {
    super(FeatureList.createProfile, disabledFeatures);
  }

  isAccessible(): boolean {
    return super.isRouteAccessible();
  }
}
